// extracted by mini-css-extract-plugin
module.exports = {"result":"styles_result__YHEEj","icon":"styles_icon__YQztu","title":"styles_title__aSrL6","description":"styles_description__XR2u3","actions":"styles_actions__yPFUO"};